/* eslint-disable @typescript-eslint/no-use-before-define */
import { Entry } from 'contentful'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import {
  IContentfulConfigurableCard,
  IContentfulConfigurableCardEntry,
} from 'types/contentful/configurableCard.types'
import { parseConfigurableSlider } from './parseConfigurableSlider'
import { parseConfigurableTile } from './parseConfigurableTile'

export const parseConfigurableCard = (
  configurableCard: Entry<IContentfulConfigurableCardEntry>
): IContentfulConfigurableCard => {
  const pairedCard = configurableCard?.fields?.pairedCard

  // We support only 1 level of pairing. So we remove the paired card if someone accidentaly added it on Contentful side.
  // Prevents this parser from risk of loop.
  if (pairedCard?.fields?.pairedCard) {
    pairedCard.fields.pairedCard = null
  }

  const card = {
    ...configurableCard?.fields,
    componentKey: 'configurableCard',
    mobileImage: mapContentfulImageAsset(configurableCard?.fields?.mobileImage),
    image: mapContentfulImageAsset(configurableCard?.fields?.image),
    cardTopBadge: mapContentfulImageAsset(
      configurableCard?.fields?.cardTopBadge
    ),
    tile: parseTile(configurableCard?.fields?.tile),
    titleConfig: configurableCard?.fields?.titleConfiguration?.fields,
    cta: configurableCard?.fields?.cta?.fields,
    pairedCard: pairedCard ? parseConfigurableCard(pairedCard) : null,
    cardFooterLinks: configurableCard?.fields?.cardFooterLinks
      ?.map((x) => x?.fields)
      ?.filter(Boolean),
  }

  return card
}

function parseTile(tile) {
  if (!tile) {
    return {}
  }

  const contentType = tile.sys?.contentType?.sys?.id
  if (contentType === 'configurableSlider') {
    return parseConfigurableSlider(tile)
  }

  if (contentType === 'configurableCard') {
    return parseConfigurableCard(tile)
  }

  if (contentType === 'configurableTile') {
    return parseConfigurableTile(tile)
  }

  return {}
}
